module.exports = __webpack_public_path__ + "static/egyptian-cotton-duvet-cover-grey-1-0e85f680c8c39d624680f8b98ae6a97a.webp";